export const BROADCAST_CHANNEL_NAME = 'pinterest_integration_channel';
